// extracted by mini-css-extract-plugin
export default {"vipPlanPriceText":"VipPlan_vipPlanPriceText__oyf6w","vipPlanPriceContainer":"VipPlan_vipPlanPriceContainer__1ka3Z"};